import { useState } from "react";
import { useCreatorReceivableSnapshots, useCreatorFinancialBankAccounts } from "../model/hooks";
import { ReceivablesDashboard } from "../ui/ReceivablesDashboard";

export function ReceivablesDashboardPage() {
  const [periodMonths, setPeriodMonths] = useState(12);
  const { snapshots, isLoading, refetch } = useCreatorReceivableSnapshots(
    { limit: 50, periodMonths },
    { placeholderData: (prev: any) => prev } as any
  );
  const { bankAccounts } = useCreatorFinancialBankAccounts();

  return (
    <div className="creator-financial-page -m-6 space-y-8 p-8 pb-8">
      <ReceivablesDashboard
        snapshots={snapshots}
        isLoading={isLoading}
        periodMonths={periodMonths}
        onPeriodChange={setPeriodMonths}
        bankAccounts={bankAccounts}
        onRefetch={refetch}
      />
    </div>
  );
}
